export default {
  props: {
    mdTheme: String
  },
  inject: ['$material'],
  computed: {
    themeClass() {
      return this.$material.getThemeClass(this.mdTheme);
    },
    themeClassOrDefault() {
      return this.$material.getThemeClass(this.mdTheme || this.$material.getDefaultTheme());
    },
  },
  methods: {
    getThemeAsset(name){
      return this.$material.getTheme(this.mdTheme).getAsset(name);
    }
  }
};
